import React from 'react';
import { observer } from 'mobx-react';

// Dependencies
import DOMPurify from 'dompurify';

const Confirm = observer(class Confirm extends React.Component {
  constructor() {
    super();
    this.closeDialog = this.closeDialog.bind(this);
    this.confirmKey = this.confirmKey.bind(this);
    this.confirmDialog = this.confirmDialog.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keydown', this.confirmKey, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.confirmKey, false);
  }

  closeDialog(e) {
    e.preventDefault();
    this.props.store.SessionStore.closeDialog();
  }

  confirmKey(e) {
    if(e.keyCode && (e.keyCode === 13 || e.keyCode === 32)) {
      this.confirmDialog(e);
    } else if(e.keyCode && e.keyCode === 27) {
      this.closeDialog(e);
    }
  }

  confirmDialog(e) {
    if(e) {
      e.preventDefault();
    }
    this.props.store.SessionStore.confirmFunc();
  }

  render() {
    const { SessionStore } = this.props.store;

    return(
      <div className="dialog dialog--confirm">
        <div className="dialog__content">
          <strong className="dialog__msg" tabIndex="0">{SessionStore.confirmContent.heading}</strong>

          <p>{SessionStore.confirmContent.body}</p>

          {SessionStore.confirmContent.data &&
            <ul dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(SessionStore.confirmContent.data)}}></ul>
          }

          <div className="dialog__btns">
            <a
              href="#app"
              className="btn btn--outline"
              onClick={(e) => this.closeDialog(e)}
            >
              {SessionStore.confirmContent.cancel ? SessionStore.confirmContent.cancel : 'Cancel'}
            </a>

            <a
              href="#app"
              className="btn"
              onClick={(e) => this.confirmDialog(e)}
            >
              {SessionStore.confirmContent.button}
            </a>
          </div>
        </div>
      </div>
    );
  }
})

export default Confirm;


// WEBPACK FOOTER //
// ./src/app/components/Common/Confirm.js